<template>
  <div class="profit-bill">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="overview">
        <div class="ring-out">
          <div class="ring-in">
            <div class="date">{{ info.incomeDate || '' }}收入(元)</div>
            <div class="amount">
              ￥{{ info.taxAllMoney || 0 | formatMoney }}
            </div>
          </div>
        </div>
      </div>
      <div class="detail">
        <div class="title">
          <i class="block"></i>
          分润收入明细
        </div>
        <div class="items">
          <div class="item">
            <div class="left">自身交易笔数</div>
            <div class="right">{{ info.selfTransactionsNum || 0 }}笔</div>
          </div>
          <div class="item">
            <div class="left">自身交易金额</div>
            <div class="right">
              ￥{{ info.selfTransactionMoney || 0 | formatMoney }}
            </div>
          </div>
          <div class="item">
            <div class="left">自身普通交易金额T0</div>
            <div class="right">￥{{ info.selfT0Money || 0 | formatMoney }}</div>
          </div>
          <div class="item">
            <div class="left">自身VIP交易额T0</div>
            <div class="right">
              ￥{{ info.selfVipT0Money || 0 | formatMoney }}
            </div>
          </div>
          <div class="item">
            <div class="left">自身交易额T1</div>
            <div class="right">￥{{ info.selfT1Money || 0 | formatMoney }}</div>
          </div>
          <div class="item">
            <div class="left">自身交易额其他</div>
            <div class="right">
              ￥{{ info.selfOtherMoney || 0 | formatMoney }}
            </div>
          </div>
          <div class="item">
            <div class="left">自身电签-mpos交易额</div>
            <div class="right">￥{{ info.selfSPMoney || 0 | formatMoney }}</div>
          </div>
          <div class="item">
            <div class="left">自身4G电签交易金额</div>
            <div class="right">￥{{ info.self4GMoney || 0 | formatMoney }}</div>
          </div>
          <div
            class="item"
            v-if="info.channelCode && info.channelCode == '0004'"
          >
            <div class="left">自身电签T1交易额</div>
            <div class="right">￥{{ info.st1Sum || 0 | formatMoney }}</div>
          </div>
          <div class="item special">
            <div class="left">下级整体交易笔数</div>
            <div class="right">{{ info.subsetTransactionNum || 0 }}笔</div>
          </div>
          <div class="item special">
            <div class="left">下级整体交易量</div>
            <div class="right">
              ￥{{ info.subsetTransactionMoney || 0 | formatMoney }}
            </div>
          </div>
          <div class="item special">
            <div class="left">下级整体交易量T0</div>
            <div class="right">
              ￥{{ info.subsetT0Money || 0 | formatMoney }}
            </div>
          </div>
          <div class="item special">
            <div class="left">下级整体交易量T1</div>
            <div class="right">
              ￥{{ info.subsetT1Money || 0 | formatMoney }}
            </div>
          </div>
          <div class="item special">
            <div class="left">下级整体交易量其他</div>
            <div class="right">
              ￥{{ info.subsetOtherMoney || 0 | formatMoney }}
            </div>
          </div>
          <div class="item">
            <div class="left">交易分润比例</div>
            <div class="right">
              {{ (info.ratio / 100 || 0) | formatMoney(3) }}%
            </div>
          </div>
          <div class="item">
            <div class="left">交易分润</div>
            <div class="right">
              ￥{{ info.transactionMoney || 0 | formatMoney }}
            </div>
          </div>
          <div class="item">
            <div class="left">管理津贴</div>
            <div class="right">
              ￥{{ info.transactionManageMoney || 0 | formatMoney }}
            </div>
          </div>
          <div class="item">
            <div class="left">皇冠比例</div>
            <div class="right">
              {{ (info.crownRatio / 100 || 0) | formatMoney(3) }}%
            </div>
          </div>
          <div class="item">
            <div class="left">皇冠津贴</div>
            <div class="right">
              ￥{{ info.crownMoney + info.dhCrownMoney || 0 | formatMoney }}
            </div>
          </div>
          <div v-if="info.firstInstitutionId != 9">
            <div class="item">
              <div class="left">4G电签皇冠比例</div>
              <div class="right">
                {{ (info.spCrownRatio / 100 || 0) | formatMoney(3) }}%
              </div>
            </div>
            <div class="item">
              <div class="left">4G电签皇冠津贴</div>
              <div class="right">
                ￥{{ info.spCrownMoney || 0 | formatMoney }}
              </div>
            </div>
          </div>
          <div class="item">
            <div class="left">钻石奖金</div>
            <div class="right">
              ￥{{ info.diamondMoney || 0 | formatMoney }}
            </div>
          </div>
          <div
            class="item"
            v-if="info.channelCode && info.channelCode == '0004'"
          >
            <div class="left">电签T1分润金额</div>
            <div class="right">￥{{ info.st1Money || 0 | formatMoney }}</div>
          </div>
          <div v-if="info.firstInstitutionId == 9">
            <div class="item">
              <div class="left">电签-mpos交易分润比例</div>
              <div class="right">￥{{ info.spRatio || 0 | formatMoney }}</div>
            </div>
            <div class="item">
              <div class="left">电签-mpos交易分润</div>
              <div class="right">
                ￥{{ info.spBaseMoney || 0 | formatMoney }}
              </div>
            </div>
            <div class="item">
              <div class="left">电签-mpos管理津贴</div>
              <div class="right">
                ￥{{ info.spMagMoney || 0 | formatMoney }}
              </div>
            </div>
            <div class="item">
              <div class="left">电签-mpos皇冠比例</div>
              <div class="right">
                ￥{{ info.spCrownRatio || 0 | formatMoney }}
              </div>
            </div>
            <div class="item">
              <div class="left">电签-mpos皇冠津贴</div>
              <div class="right">
                ￥{{ info.spCrownMoney || 0 | formatMoney }}
              </div>
            </div>
            <div class="item">
              <div class="left">电签-mpos钻石奖金</div>
              <div class="right">
                ￥{{ info.spDiamMoney || 0 | formatMoney }}
              </div>
            </div>
          </div>

          <div class="item special">
            <div class="left">四项总计</div>
            <div class="right">￥{{ info.allMoney || 0 | formatMoney }}</div>
          </div>
          <div class="item">
            <div class="left">四项税后</div>
            <div class="right">￥{{ info.taxAllMoney || 0 | formatMoney }}</div>
          </div>
          <div style="color: #0001">{{ info.channelCode }}</div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { WSBridge, platformAgent, formatMoney, jiemi } from '@/utils/utils'
import { getIncome } from '@/api/profit/profit'
import { Toast } from 'vant'
export default {
  filters: {
    formatMoney
  },
  data() {
    return {
      info: {},
      isLoading: false,
      incomeId: this.$route.query.incomeId,
      frDate: this.$route.query.frDate
    }
  },
  created() {
    this.incomeId = parseInt(this.incomeId)
    console.log(this.$route.query, '地址栏参数')
    if (this.incomeId == '0' || this.incomeId == 0) {
      let type = this.$route.query.type
      if (this.$route.query.frPolicy == 'H') {
        type = 33
      }
      if (this.$route.query.frPolicy == 'C') {
        type = 31
      }
      let query = {
        frDate: this.frDate,
        type
      }
      console.log('请求query', query)
      this.$router.replace({
        path: '/profit-bill-general-revision',
        query
      })
      return
    } else {
      this.init()
    }
  },
  methods: {
    init() {
      getIncome({
        action: 'get_income',
        incomeId: this.incomeId
      }).then(result => {
        this.info = result || {}
        if (JSON.stringify(this.info) == '{}') {
          // Toast('未查到分润明细数据')
        }
      })
      return
      let result = WSBridge.nativeHttpEncrypt({
        params: {
          action: 'get_income',
          incomeId: this.incomeId
        },
        success: res => {
          this.getEncryptParams(res)
        }
      })
      if (platformAgent() == 'android') {
        this.getEncryptParams(result)
      }
    },
    getEncryptParams(result) {
      if (typeof result == 'string') {
        result = JSON.parse(result)
      }
      let headers = result.headers
      if (typeof headers == 'string') {
        headers = JSON.parse(headers)
      }
      this.$store.commit('SET_QUERYS', headers)
      let body = result.body
      if (typeof body == 'string') {
        body = JSON.parse(body)
      }
      let token = result.token
      getIncome(body).then(
        res => {
          if (!res) {
            return
          }
          let params = token + '#' + JSON.stringify(res)
          let ret = WSBridge.nativeHttpDecrypt({
            params,
            success: res => {
              this.getDecryptResult(res)
            }
          })
          if (platformAgent() == 'android') {
            this.getDecryptResult(ret)
          }
        },
        err => {
          alert('err: ' + err)
        }
      )
    },
    getDecryptResult(result) {
      result = jiemi(result)
      if (typeof result == 'string') {
        result = JSON.parse(result)
      }
      this.info = result.data || {}
      if (JSON.stringify(this.info) == '{}') {
        Toast('未查到分润明细数据')
      }
    },
    onRefresh() {
      this.init()
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
    }
  }
}
</script>
